import { DestroyRef, inject, Injectable } from '@angular/core';
import { NgxIndexedDBService, WithID } from 'ngx-indexed-db';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { IndexDBName } from '../global/constants/constant';
import { IndexDbKeys } from '../../proxy/models/index-db-keys';

@Injectable({
  providedIn: 'root'
})
export class IndexDbService {
  private dbService = inject(NgxIndexedDBService);
  private destroyRef = inject(DestroyRef);

  public add(data: { key: IndexDbKeys, value: any, checkSumValue?: null | string }): Observable<{
    key: IndexDbKeys;
    value: string;
    expirationDate: number;
    checkSumValue: string | null
  } & WithID> {
    this.removeByKey(data.key);
    const newData = {
      key: data.key,
      value: data.value,
      expirationDate: new Date().getTime() + 24 * 60 * 60 * 1000,
      checkSumValue: data?.checkSumValue || null,
    }
    return this.dbService.add(IndexDBName, newData);
  }

  public getValueByKey<T>(key: IndexDbKeys): Observable<any> {
    return this.dbService.getByKey<T>(IndexDBName, key).pipe(
      map((data: any) => {
        if (data?.value && new Date().getTime() <= data.expirationDate) {
          return JSON.parse(data.value);
        }
        return undefined;
      }),
    );
  }

  public getByKey<T>(key: IndexDbKeys): Observable<any> {
    return this.dbService.getByKey<T>(IndexDBName, key).pipe(
      map((data: any) => {
        if (data?.value && new Date().getTime() <= data.expirationDate) {
          return data;
        }

        return undefined;
      }),
      catchError(() => {
        return of(false);
      }),
    );
  }

  public removeByKey(key: IndexDbKeys): void {
    this.dbService.deleteByKey(IndexDBName, key).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
